import { Permissions } from '../../../../accessControl/permissions';
import { DISCIPLINES } from '../../../../utils/new_discipline';
import { IMenuItem, ISubMenuItem } from '../menuBar/menuItems';

const disciplines: ISubMenuItem[] = DISCIPLINES.map((discipline) => ({
  permission: discipline.permission,
  label: discipline.name,
  icon: discipline.icon,
  iconType: 'svg',
  link: `/disciplinas/${discipline.slug}`,
  old: false,
  isNew: false,
  disabled: discipline.disabled,
}));

export const menuItems: IMenuItem[] = [
  {
    id: 'minha-area',
    label: 'Minha Área',
    icon: 'home',
    iconType: 'material',
    items: [],
    old: false,
    href: '/minha-area',
    clickable: true,
    permission: Permissions.MINHA_AREA,
  },
  {
    id: 'disciplinas',
    label: 'Disciplinas',
    icon: 'neurology',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: disciplines,
  },
  {
    id: 'favoritos',
    label: 'Favoritos',
    icon: 'star',
    iconType: 'material',
    old: false,
    clickable: true,
    href: '/favoritos',
    items: [],
    permission: Permissions.FAVORITOS,
  },
  {
    id: 'mais',
    label: 'Mais',
    icon: 'menu',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/mais',
    items: [
      {
        label: 'Sair',
        icon: 'logout',
        iconType: 'material',
        link: '/logout',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Perfil',
        icon: 'person',
        iconType: 'material',
        link: '/perfil',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Fale conosco',
        icon: 'contact_support',
        iconType: 'material',
        link: 'https://aprovatotal.zendesk.com/hc/pt-br/requests/new',
        externalLink: true,
        old: false,
        permission: Permissions.ALUNO_APROVA_TOTAL,
      },
    ],
  },
];
